import React from 'react';
import './QCDDailyMinMax.scss';
import { QCD_DAILY_MIN_MAX_MODAL } from '../../../redux/modules/modals/modals.module';
import { isYearAfter2024, getCurrentYear } from '../../../settings/settings';

const QCDDailyMinMax = ({ closeModal }) => {
  return (
    <div>
      <div className="text">
        <h1 className="header">Your Minimums & Maximums</h1>
        <p className="p">
          The <strong className="bold-text">minimum</strong> dollar amount that
          can be distributed to a charity or redeemed from a fund for a QCD
          requested online is $1.00.
        </p>
        <p className="p">
          The <strong className="bold-text">maximum</strong> total dollar amount
          is ${isYearAfter2024() ? '108,000' : '105,000'} for a QCD requested
          online when either the “Send a check directly to my chosen charity” or
          the “Mail a check to my address of record” option is selected.
        </p>

        <p className="p">
          Please note that generally, the maximum annual exclusion from income
          per individual is ${isYearAfter2024() ? '108,000' : '105,000'} for{' '}
          {getCurrentYear()} (adjusted for inflation) from IRAs to qualified
          charities.
        </p>

        <p className="p">
          <strong className="bold-text">Fund Maximum Threshold </strong> - The
          current value of your fund account, which is based on the prior market
          day's closing prices, may be higher or lower than the closing market
          value of your fund account at the end of the day due to market
          fluctuation. If you submit a redemption request for a dollar amount
          that exceeds the closing market value of your fund account, your
          transaction will fail and not be executed.
        </p>
      </div>
      <button
        onClick={() => {
          closeModal(QCD_DAILY_MIN_MAX_MODAL);
        }}
        className="OK-button"
      >
        OK
      </button>
    </div>
  );
};

export default QCDDailyMinMax;
